module.exports = __webpack_public_path__ + "static/media/CODE2000.052eaff1.TTF";